import { NewOrderModal } from '@/components/Orders/Dashboard/NewOrderModal';
import { createNewOrderDraft, type NewOrderDraft } from '@/components/Orders/Dashboard/NewOrderDraft';
import { getUser } from '@/library/UserSessionHelper';
import { getOrderRefreshRate, orderSettingsKeys, type OrderRefreshRate } from '@/library/OrderSettingsHelper';
import styles from './OrdersPage.module.scss';
import Orders from '../../components/Orders';
import OrdersNavbar from '@/layout/OrdersNavbar/OrdersNavbar';
import { ordersCacheRefreshHelper } from '@/library/OrdersCacheRefreshHelper';
import { useEffect, useState } from 'react';
import { SettingsModal } from '@/components/Orders/Dashboard/SettingsModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { getOrdersPage, ordersPresentation, OrdersPageType } from '@/components/Orders/Dashboard/OrdersPresentation';

export default function OrdersPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = getOrdersPage(location.hash);
  const [newOrderDraft, setNewOrderDraft] = useState<NewOrderDraft | null>(null);
  const [refreshRate, setRefreshRate] = useState<OrderRefreshRate>(5);
  const [settingsPage, setSettingsPage] = useState<OrdersPageType | null>(null);

  const setCurrentPage = (value: OrdersPageType) => {
    navigate({ pathname: location.pathname, search: location.search, hash: `#${value.toLowerCase()}` });
  };

  useEffect(() => {
    setSettingsPage(null);
    setNewOrderDraft(null);
    let cancelled = false;
    const loadRefreshRate = async () => {
      try {
        const user = await getUser();
        if (!cancelled) setRefreshRate(getOrderRefreshRate(user?.orderSettings?.[orderSettingsKeys[currentPage]]?.appUserSetting?.setting));
      } catch (error) {
        console.error('Could not load order refresh rate:', error);
      }
    };
    void loadRefreshRate();
    return () => {
      cancelled = true;
    };
  }, [currentPage]);

  useEffect(() => {
    void ordersCacheRefreshHelper.start();
    return () => ordersCacheRefreshHelper.stop();
  }, []);

  return (
    <div className={styles.pageLayout}>
      <OrdersNavbar
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onOpenSettings={() => {
          setNewOrderDraft(null);
          setSettingsPage(currentPage);
        }}
        onNewOrder={() => {
          setSettingsPage(null);
          setNewOrderDraft(createNewOrderDraft(ordersPresentation[currentPage].orderType));
        }}
      />
      <main className={`${styles.main} ${styles.navbarOffset}`}>
        <Orders key={currentPage} currentPage={currentPage} refreshRate={refreshRate} />
      </main>
      {newOrderDraft && <NewOrderModal draft={newOrderDraft} onChange={setNewOrderDraft} onClose={() => setNewOrderDraft(null)} onNext={(draft) => console.log('New order draft:', { ...draft })} />}
      {settingsPage === currentPage && <SettingsModal onSaved={setRefreshRate} key={currentPage} currentPage={currentPage} onClose={() => setSettingsPage(null)} />}
    </div>
  );
}
